/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Component imports
import { Button, Col, Form, Row, Typography } from 'antd';
import { WarningOutlined } from '@ant-design/icons';

// Misc imports
import userHasEditAccess from '../../utils/misc/hasEditAccess';
import useTheme from '../../utils/hooks/useTheme';

const BotDeploymentsDangerZoneForm = ({
  formData = {},
  userRoles = {},
  isCreateMode = false,
  onDeleteClick = () => {}
}) => {
  const { t } = useTranslation();
  const { formProps } = useTheme();
  const hasEditAccess = isCreateMode ? true : userHasEditAccess(formData?.tenant?.organizationId, userRoles?.organizationRoles, formData?.tenant.id, userRoles?.tenantRoles, true);

  return hasEditAccess ? (
    <Fragment>
      <Row gutter={formProps.rowGutter} className="mb-5">
        <Col span={24}>
          <Typography.Text className="fs-base text-error">
            <WarningOutlined className="mr-1 fs-lg" />  {t('In this section you can perform non-reversible actions that may affect the behavior of the agent.')}
          </Typography.Text>
        </Col>
      </Row>

      <Row gutter={formProps.rowGutter} className={formProps.flexDirection}>
        <Col span={formProps.mainColSpan}>
          <Typography.Text className="fs-base">
            {t('Deployment Deletion')}
          </Typography.Text>
          <Typography.Paragraph className="fs-sm" type="secondary">
            {t('Delete the current deployment, including all the settings.')}
          </Typography.Paragraph>
        </Col>

        <Col span={formProps.secondaryColSpan}>
          <Form.Item>
            <Button
              className="float-left"
              type="primary"
              size="large"
              danger
              onClick={() => onDeleteClick(formData.id)}
            >
              {`${t('Delete this Deployment')}`}
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Fragment>
  ) : null;
};

BotDeploymentsDangerZoneForm.propTypes = {
  formData: PropTypes.object,
  userRoles: PropTypes.object,
  isCreateMode: PropTypes.bool,
  onDeleteClick: PropTypes.func
};

export default BotDeploymentsDangerZoneForm;
